/**
 * Texte brut : jamais interprété comme HTML, SQL ou code.
 */

const CONTROL_CHARS_RE =
  /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F\u202A-\u202E\u2066-\u2069]/g;

const DANGEROUS_BLOCK_TAGS = [
  "script",
  "style",
  "iframe",
  "object",
  "embed",
  "svg",
  "math",
  "template",
  "noscript",
  "applet",
  "frame",
  "frameset",
  "portal",
];

const DANGEROUS_VOID_TAGS_RE =
  /<\/?(?:link|meta|base|form|img|video|audio|source|track|picture|input|button|textarea|select|html|head|body|!doctype)\b[^>]*>/gi;

const HTML_COMMENT_RE = /<!--[\s\S]*?-->/g;
const EVENT_ATTR_RE =
  /\son[a-zA-Z]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/g;

export const SAFE_ID_RE = /^[A-Za-z0-9_-]{1,80}$/;

export function asPlainString(raw) {
  if (typeof raw === "string") return raw;
  if (typeof raw === "number" && Number.isFinite(raw)) return String(raw);
  return "";
}

export function getUtf8Bytes(content) {
  const value = typeof content === "string" ? content : "";
  if (typeof Buffer !== "undefined" && typeof Buffer.byteLength === "function") {
    return Buffer.byteLength(value, "utf8");
  }
  if (typeof TextEncoder !== "undefined") {
    return new TextEncoder().encode(value).length;
  }
  return value.length;
}

function decodeHtmlEntitiesOnce(value) {
  return value
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#0*39;/g, "'")
    .replace(/&#x0*27;/gi, "'")
    .replace(/&apos;/gi, "'")
    .replace(/&#(\d+);/g, (_, digits) => {
      const code = Number(digits);
      if (!Number.isFinite(code) || code < 1 || code > 0x10ffff) return "";
      return String.fromCodePoint(code);
    })
    .replace(/&#x([0-9a-f]+);/gi, (_, hex) => {
      const code = parseInt(hex, 16);
      if (!Number.isFinite(code) || code < 1 || code > 0x10ffff) return "";
      return String.fromCodePoint(code);
    })
    .replace(/&amp;/gi, "&");
}

function stripDangerousMarkup(text) {
  let value = text;
  value = value.replace(HTML_COMMENT_RE, "");
  for (const tag of DANGEROUS_BLOCK_TAGS) {
    const block = new RegExp(`<${tag}\\b[^>]*>[\\s\\S]*?<\\/${tag}>`, "gi");
    const open = new RegExp(`<${tag}\\b[^>]*>`, "gi");
    const close = new RegExp(`<\\/${tag}>`, "gi");
    value = value.replace(block, "").replace(open, "").replace(close, "");
  }
  value = value.replace(DANGEROUS_VOID_TAGS_RE, "");
  value = value.replace(/<a\b[^>]*>/gi, "").replace(/<\/a>/gi, "");
  value = value.replace(EVENT_ATTR_RE, "");
  return value;
}

export function neutralizeExecutableText(text) {
  let previous = "";
  let value = text;
  for (let i = 0; i < 3 && value !== previous; i += 1) {
    previous = value;
    value = decodeHtmlEntitiesOnce(value);
    value = stripDangerousMarkup(value);
  }
  return value;
}

export function sanitizeSingleLine(raw) {
  return neutralizeExecutableText(asPlainString(raw))
    .replace(CONTROL_CHARS_RE, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function sanitizeMultiline(raw) {
  return neutralizeExecutableText(asPlainString(raw))
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .replace(CONTROL_CHARS_RE, "");
}

export function visibleLength(text) {
  return asPlainString(text).replace(/\s+/g, "").length;
}

export function normalizeSafeId(raw) {
  const value = asPlainString(raw).trim();
  return SAFE_ID_RE.test(value) ? value : "";
}
